var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.cryptoClass,attrs:{"data-nb":_vm.priceInCurrency},on:{"click":_vm.openLink}},[(_vm.crypto.symbol)?_c('div',[_vm._v("\n    "+_vm._s(_vm.crypto.symbol)+"\n    "),_c('span',[_vm._v(_vm._s(_vm.crypto.name))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }